import { returnErrors } from './errorAction';
import { RESET_LOADING, GET_REPORT, GET_REPORT1, GET_NEXT_REPORT, GET_DETAILED_REPORT, GET_OLD_REPORT, GET_OLD_NEXT_REPORT, GET_DOWNLOAD_REPORT, GET_DOWNLOAD_REPORT1, PROCTORING_REPORT } from '../Types/types';
import { getApiCall, getV2ApiCall, handle403Logout, postApiCall, putApiCall } from '../../utils/request';
import axios from 'axios';
import { error } from 'highcharts';

export const getReport = (id, query, page, row, sort) => async (dispatch) => {
    try {
        const response = await getApiCall(`candidate/list-report?TestId=${id}&SearchText=${query}&PageNumber=${page}&DisplayRows=${row}&sortby=${sort}`);
        if (response?.status === 200) {
            return dispatch({ type: GET_REPORT, payload: response.data });
        } else if (response?.status === 204) {
            dispatch({ type: GET_REPORT1, payload: [] });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const  getDownloadReport = (id) => async (dispatch) => {
    try {
        const response = await getApiCall(`candidate/download-report?TestId=${id}`);
        if (response?.status === 200) {
            return dispatch({type : GET_DOWNLOAD_REPORT, payload: response.data})
        } else if (response?.status === 204) {
            dispatch({ type : GET_DOWNLOAD_REPORT1, payload: []});
        } else {
            returnErrors(dispatch,error.response?.data?.responseMessages[0]?.message, error?.response.status);
        }
        
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.message, error?.response?.status);
    }
} 

export const getNextReport = (id, query, page, row, sort) => async (dispatch) => {
    try {
        const response = await getApiCall(`candidate/list-report?TestId=${id}&SearchText=${query}&PageNumber=${page}&DisplayRows=${row}&sortby=${sort}`);
        if (response?.status === 200) {
            return dispatch({ type: GET_NEXT_REPORT, payload: response.data });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const getOldReport = (id, query, page, row) => async (dispatch) => {
    try {
        const response = await getApiCall(`candidate/candidate-report?tenentId=${id}&SearchText=${query}&Pagenumber=${page}&PageSize=${row}&IsTestAttempt=true`);
        if (response?.status === 200) {
            return dispatch({ type: GET_OLD_REPORT, payload: response.data });
        } else if (response?.status === 204) {
            dispatch({ type: GET_OLD_REPORT, payload: [] });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const getOldNextReport = (id, query, page, row) => async (dispatch) => {
    try {
        const response = await getApiCall(`candidate/candidate-report?tenentId=${id}&SearchText=${query}&Pagenumber=${page}&PageSize=${row}&IsTestAttempt=true`);
        if (response?.status === 200) {
            return dispatch({ type: GET_OLD_NEXT_REPORT, payload: response.data });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}


export const getDetailedReport = (id) => async (dispatch) => {
    try {
        const response = await getV2ApiCall(`candidate/detailed-report?InviteId=${id}`);
        if (response?.status === 200) {
            return dispatch({ type: GET_DETAILED_REPORT, payload: response.data.report });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        dispatch({ type: GET_DETAILED_REPORT, payload: null });
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}


// export const getDetailedReport = (id) => async (dispatch) => {
//     try {
//         const response = await getApiCall(`candidate/detailed-report?InviteId=${id}`);
//         if (response?.status === 200) {
//             return dispatch({ type: GET_DETAILED_REPORT, payload: response.data.report });
//         }
//         else {
//             returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status)
//         }
//     }
//     catch (error) {
//         returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
//     }
// }

export const getDetailedOldReport = (id) => async (dispatch) => {
    try {
        const response = await getApiCall(`candidate/candidate-report-details?CandidateSendInviteId=${id}`);
        if (response?.status === 200) {
            return dispatch({ type: GET_DETAILED_REPORT, payload: response.data });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status)
        }
    }
    catch (error) {
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const resetLoading = () => async (dispatch) => {
    try {
        return dispatch({ type: RESET_LOADING });
    }
    catch (error) {
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const updatedScore = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`test/update-candidate-question-score`, obj);
        console.log(response.data)
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const updateCandidateScore = (payload) => async (dispatch) => {
    try {
        const response = await postApiCall(`candidate/update-score`, payload);
        if (response?.status === 200) {
            return { success: true, data: response.data };
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
            return { success: false };
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
        return { success: false };
    }
};


export const getProctotingAnalysis = (candidateTestId) => async (dispatch) => {
    try {
        const response = await getApiCall(`Proctoring/${candidateTestId}/analysis`);
        if (response?.status === 200) {
            return dispatch({ type: PROCTORING_REPORT, payload: response.data.analysis });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status)
        }
    }
    catch (error) {
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const getCandidateQuestionComments = (candidateQuestionId) => async (dispatch) => {
    try {
        const response = await getApiCall(`candidate-test-comments/question/${candidateQuestionId}`);
        if (response?.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
            return { success: true, data: response.data };
        } else {
            return { success: false, data: [] };
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
        return { success: false };
    }
};


export const markReviewStatus = (candidateTestId, isViolated, commentText, stateType, reportId) => async (dispatch) => {
    try {
        const response = await postApiCall(`candidate/mark-review-status`, {
            candidateTestId,
            isViolated,
            commentText,
        });
        if (response?.status === 200) {
            if (stateType === 'new') {
                await dispatch(getDetailedReport(reportId));
            } else {
                await dispatch(getDetailedOldReport(reportId));
            }
            return { success: true, data: response.data };
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
            return { success: false };
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
        return { success: false };
    }
};

export const uploadCandidateAnswerFile = (file, candidateTestQuestionId, candidateTestAnswerId, invitationToken) => async (dispatch) => {
    try {
        const formData = new FormData();
        formData.append("file", file);

        const token = localStorage.getItem("token");
        const uploadResponse = await axios.post(
            process.env.REACT_APP_API_KEY + `storage/create`,
            formData,
            { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
        );

        if (!uploadResponse?.data?.url) {
            return { success: false, message: "File upload failed" };
        }

        const payload = {
            token: invitationToken || "",
            candidateTestQuestionId,
            candidateTestAnswerId: candidateTestAnswerId || 0,
            files: [{ name: file.name, url: uploadResponse.data.url }],
        };

        const response = await putApiCall(`test/candidate-answer-files`, payload);
        if (response?.status === 200) {
            return { success: true };
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
            return { success: false };
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
        return { success: false, message: "Upload failed" };
    }
};

export const addCandidateTestComment = (payload) => async (dispatch) => {
  try {
    const response = await postApiCall(`candidate-test-comments/add`, payload);
    if (response?.status === 200) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response?.data?.responseMessages?.[0]?.message || 'Failed to add comment' };
    }
  } catch (error) {
    handle403Logout(error);
    const message = error?.response?.data?.responseMessages?.[0]?.message || 'Failed to add comment';
    return { success: false, message };
  }
};